import api from 'api'

export const updateForm = async (formId, payload) => {
  const { data } = await api.put(`/form/${formId}`, payload)

  return data
}